import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon } from "@hugeicons/core-free-icons";
import { useHotkeys } from 'react-hotkeys-hook';
import { cn } from "@/lib/utils";

const Shortcuts = ({
  classes = {},
  className = "",
  onClick = () => {}
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useHotkeys('shift+/', () => { handleClickOpen() })

  const shortcutData = [
    { key: "g", key1: "+", key2: "d", func: "Dashboard", combi: true },
    { key: "g", key1: "+", key2: "c", func: "Clients", combi: true },
    { key: "g", key1: "+", key2: "f", func: "Flows", combi: true },
    { key: "g", key1: "+", key2: "h", func: "Chat Hub", combi: true },
    { key: "g", key1: "+", key2: "i", func: "Invoice", combi: true },
    { key: "g", key1: "+", key2: "p", func: "Profile", combi: true },
    { key: "g", key1: "+", key2: "t", func: "Tasks", combi: true },
    { key: "g", key1: "+", key2: "a", func: "Teams", combi: true },
    { key: "?", func: "Shortcut Help", combi: false },
  ]

  return (
    <div>
      <Button id="openDialogue" onClick={handleClickOpen} className="hidden">
      </Button>
      <Dialog open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
        <DialogContent className="sm:max-w-md keyboardDialog">
          <DialogHeader>
            <DialogTitle className="text-2xl dialogueTitle">
              Keyboard shortcuts
            </DialogTitle>
            <Button 
              variant="ghost" 
              size="icon" 
              className="absolute right-4 top-4 closeButton" 
              onClick={handleClose}
            >
              <HugeiconsIcon icon={Cancel01Icon} className="h-4 w-4" />
            </Button>
          </DialogHeader>
          <div className="space-y-2 py-4">
            {shortcutData && shortcutData.map((item, index) => (
              <div key={index} className="flex items-center justify-between py-2 keyboardText">
                <div className="text-[15px] text-foreground">{item["func"]}</div>
                <div className="flex items-center gap-1 keyBtns">
                  {item.combi ? (
                    <>
                      <div className="keyBtn w-[26px] h-[26px] flex items-center justify-center bg-muted border rounded-sm shadow-sm">
                        {item["key"]}
                      </div>
                      <div className="keyBtnPlus px-1.5">{item["key1"]}</div>
                      <div className="keyBtn w-[26px] h-[26px] flex items-center justify-center bg-muted border rounded-sm shadow-sm">
                        {item["key2"]}
                      </div>
                    </>
                  ) : (
                    <div className="keyBtn w-[26px] h-[26px] flex items-center justify-center bg-muted border rounded-sm shadow-sm">
                      {item["key"]}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

// prop types
Shortcuts.propTypes = {
  onClick: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string
};

export default Shortcuts;
